module.exports = __webpack_public_path__ + "assets/images/two_83b0848cb8c717dcbe8c5419e1abd588.png";